export const SET_CART_PROPS = "SET_CART_PROPS";
export const INIT_CART_PROPS = "INIT_CART_PROPS";
export const START_ADDING_ITEMS_TO_EVENT = "START_ADDING_ITEMS_TO_EVENT";
export const STOP_ADDING_ITEMS_TO_EVENT = "STOP_ADDING_ITEMS_TO_EVENT";
export const ADD_BUNDLE_IN_CART = "ADD_BUNDLE_IN_CART";
export const UPDATE_BUNDLE_IN_CART = "UPDATE_BUNDLE_IN_CART";
